<div class="min-h-screen p-8">
  <div class="mb-5 px-1">
    <h2 class="textTabsColor text-[26px] font-bold">
      <span i18n="@@addSubProductTitleform">Add Sub Product for:</span>
      {{ productDisplayName() }}
    </h2>
  </div>

  <div class="flex flex-col gap-6 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
    <app-sub-product-form
      #subForm
      [productId]="productId()"
      [attributes]="attributes()"
      [categories]="categories()"
      [parentTitleEn]="parentTitleEn()"
      [parentTitleAr]="parentTitleAr()"
      [existingSubProducts]="subProductsList()"
      (onAdded)="onSubProductAdded($event)" />

    <div class="mt-4 flex justify-end gap-4">
      <button
        type="button"
        (click)="onBack.emit()"
        class="cursor-pointer rounded-xl border border-gray-300 px-8 py-2.5 font-bold text-gray-500 hover:bg-gray-50"
        i18n="@@product.button.back">
        Back
      </button>

      <button
        type="button"
        (click)="handleFinalSave()"
        [disabled]="subProductsList().length === 0"
        class="bg-primary cursor-pointer rounded-xl px-12 py-2.5 font-bold text-white shadow-md disabled:opacity-50"
        i18n="@@subProduct.button.Save">
        Save
      </button>
    </div>
  </div>

  @if (showSubProductSuccess()) {
    <app-successful-notification
      type="success"
      i18n-title="@@subProduct.success.added"
      title="Sub-product has been added successfully." />
  }
</div>
